<template>
  
  <rect
    :style  = "style"
    :x      = "shape.x"
    :y      = "shape.y"
    :width  = "shape.width"
    :height = "shape.height"
  />

</template>

<script>

export default {

  // #region Properties

  props: {
    shape: Object
  },
  computed: {
    style() {
      return {
        'fill':             'transparent',
        'stroke-dasharray': '4 6',
        'vector-effect':    'non-scaling-stroke',
        'stroke':           '#0099ee',
        'stroke-width':     '1'
      }
    }
  }

  // #endregion Properties

}

</script>